/** Ключ підписки Web Push цього браузера: його пише профіль, читає вихід (notifications-channels.md, розд. 4). */
export const PUSH_DEVICE_KEY = 'clientline.push.subscription';
